/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NotificationBarQueryVariables = {
    read: boolean;
    cancelled: boolean;
    expired: boolean;
    delivered: boolean;
};
export type NotificationBarQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"NotificationBar_viewer">;
    };
};
export type NotificationBarQuery = {
    readonly response: NotificationBarQueryResponse;
    readonly variables: NotificationBarQueryVariables;
};



/*
query NotificationBarQuery(
  $read: Boolean!
  $cancelled: Boolean!
  $expired: Boolean!
  $delivered: Boolean!
) {
  viewer {
    ...NotificationBar_viewer_3amd9C
  }
}

fragment NotificationBar_viewer_3amd9C on Viewer {
  broadcastNotifications(first: 3, read: $read, cancelled: $cancelled, expired: $expired, delivered: $delivered) {
    total
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        read {
          createdAt
        }
        broadcast {
          message
          title
          id
        }
        __typename
      }
      cursor
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cancelled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "delivered"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "expired"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "read"
},
v4 = {
  "kind": "Variable",
  "name": "cancelled",
  "variableName": "cancelled"
},
v5 = {
  "kind": "Variable",
  "name": "delivered",
  "variableName": "delivered"
},
v6 = {
  "kind": "Variable",
  "name": "expired",
  "variableName": "expired"
},
v7 = {
  "kind": "Variable",
  "name": "read",
  "variableName": "read"
},
v8 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  },
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationBarQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "NotificationBar_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "NotificationBarQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "BroadcastNotificationConnection",
            "kind": "LinkedField",
            "name": "broadcastNotifications",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "total",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BroadcastNotificationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BroadcastNotification",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BroadcastNotificationRead",
                        "kind": "LinkedField",
                        "name": "read",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Broadcast",
                        "kind": "LinkedField",
                        "name": "broadcast",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "filters": [
              "read",
              "cancelled",
              "expired",
              "delivered"
            ],
            "handle": "connection",
            "key": "NotificationBar_broadcastNotifications",
            "kind": "LinkedHandle",
            "name": "broadcastNotifications"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bcbacf0c414dad6a4e220895da17fda4",
    "id": null,
    "metadata": {},
    "name": "NotificationBarQuery",
    "operationKind": "query",
    "text": "query NotificationBarQuery(\n  $read: Boolean!\n  $cancelled: Boolean!\n  $expired: Boolean!\n  $delivered: Boolean!\n) {\n  viewer {\n    ...NotificationBar_viewer_3amd9C\n  }\n}\n\nfragment NotificationBar_viewer_3amd9C on Viewer {\n  broadcastNotifications(first: 3, read: $read, cancelled: $cancelled, expired: $expired, delivered: $delivered) {\n    total\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      node {\n        id\n        read {\n          createdAt\n        }\n        broadcast {\n          message\n          title\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e1b0b0c12f2d03d00a461e90d8417bd5';
export default node;
